import React from 'react';
import PropTypes from 'prop-types';

import { SectionLabel, ChipRow, Chip, RecentsBlock } from '../styles';

const ICON_SIZE = 16;

/**
 * "Últimas telas" (§2.4/§4): chips escuros com as telas visitadas mais
 * recentemente, já revalidadas contra a árvore de permissões pelo
 * `useRecentScreens`.
 *
 * Sem histórico, a seção inteira some — nem título, nem estado vazio (§4).
 */
function RecentChips({ recents, onNavigate }) {
   if (!recents.length) return null;

   return (
      <RecentsBlock>
         <SectionLabel>Últimas telas</SectionLabel>
         <ChipRow>
            {recents.map((item) => {
               const Icon = item.icon;
               return (
                  <Chip
                     key={item.to}
                     to={item.to}
                     onClick={() => onNavigate(item)}
                     title={
                        item.groupName
                           ? `${item.moduleName} › ${item.groupName}`
                           : item.moduleName
                     }
                  >
                     {Icon ? <Icon size={ICON_SIZE} /> : null}
                     <span>{item.label}</span>
                  </Chip>
               );
            })}
         </ChipRow>
      </RecentsBlock>
   );
}

RecentChips.propTypes = {
   recents: PropTypes.arrayOf(
      PropTypes.shape({
         to: PropTypes.string.isRequired,
         label: PropTypes.string.isRequired,
      })
   ).isRequired,
   onNavigate: PropTypes.func.isRequired,
};

export default RecentChips;
